import { Component, HostListener, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ApiService, LoggerService } from 'angular-lib';
import { LoaderService } from '../../services/loader.service';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
// OBSERVABLE GLOBAL IMPORT
// observable
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/throw';
// operators
import 'rxjs/add/operator/first';

@Component({
    selector: 'ez-app',
    template: require('./app.component.html'),
    styles: [
        require('../../less/styles.less'),
        require('../../../../node_modules/ngx-swiper-wrapper/dist/lib/swiper.component.css')
    ],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    private backPressed: boolean = false;
    private previousScroll: number = 0;
    private firstLang: string;

    @HostListener('window:TaCOpen') private onTaCOpen() {
        this.router.navigate(['/cookies']);
    }

    @HostListener('window:TaCClose') private onTaCClose() {
        this.router.navigate(['/cookies']);
    }

    constructor(
        translate: TranslateService,
        private apiService: ApiService,
        private loaderService: LoaderService,
        private router: Router,
        private location: Location,
        @Inject(DOCUMENT) private document: Document
    ) {
        // define log level from environment files
        LoggerService.setLogLevel(environment.logLevel);

        let locale = localStorage.getItem('locale');
        if (locale === null) {
            locale = window.navigator.language;
            localStorage.setItem('locale', locale);
        }

        this.firstLang = locale;
        moment.locale(locale);
        translate.use(locale);

        translate.onLangChange.subscribe((event: LangChangeEvent) => {
            if (this.firstLang !== event.lang) {
                this.loaderService.hide();
            }
        });
    }

    public ngOnInit(): void {
        // on back button pressed
        this.location.subscribe(() => {
            this.backPressed = true;
        });
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationStart && !this.backPressed) {
                // save scrolling Y position before starting navigation
                this.previousScroll = window.scrollY;
            }
            if (event instanceof NavigationEnd) {
                if (this.backPressed === false) {
                    LoggerService.info('URL CHANGED : SCROLLING TOP');
                    // scroll to top
                    window.scrollTo(0, 0);
                } else {
                    this.backPressed = false;
                    // scroll to previous saved scrollY
                    window.scrollTo(0, this.previousScroll);
                    this.previousScroll = 0;
                }
            }
        });

        // this.apiService.colors()
        //     .subscribe(
        //         colors => {
        //             less.modifyVars(colors);
        //         }
        //     );
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/app/app.component.ts